export default "__VITE_ASSET__DZ8fRklO__"